import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "@jti/ui/components/Button";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { TitleBorderContainer, Typography } from "@jti/ui-library";
import getCurrentDescription from "../../utils/getCurrentDescription";
const DESCRIPTION_LIMIT = 300;
export const ProductDescription = ({ description }) => {
    const [showLongDescription, setShowLongDescription] = useState(false);
    const { __ } = useTranslations();
    const toggleDescription = (event) => {
        event.preventDefault();
        setShowLongDescription(!showLongDescription);
    };
    return (_jsxs(TitleBorderContainer, { title: __("product.info.description"), testId: "descriptionBlock", children: [_jsx(Typography, { variant: "subtitle", component: "div", color: "primary", isDangerous: true, className: "pdpDescription", children: getCurrentDescription(description, showLongDescription, DESCRIPTION_LIMIT) }), description.length > DESCRIPTION_LIMIT && (_jsx("div", { className: "product-information-block__read-more", children: _jsx(Button, { onClick: toggleDescription, variant: "cta", color: "tertiary", children: __(showLongDescription ? "product.info.readLess" : "product.info.readMore") }) }))] }));
};
//# sourceMappingURL=ProductDescription.js.map